module.exports = __webpack_public_path__ + "static/media/taxploration-logo.6c7b0b69.png";